interface Props {
  files: File[];
  onFiles: (files: File[]) => void;
}

export function FileDropzone({ files, onFiles }: Props) {
  return (
    <section className="card">
      <div className="section-header">
        <div>
          <h2>1. Arquivos AFD</h2>
          <p>Selecione um ou mais arquivos .txt exportados do relógio de ponto.</p>
        </div>
      </div>
      <label className="dropzone">
        <input
          type="file"
          multiple
          accept=".txt,text/plain"
          onChange={(event) => onFiles(Array.from(event.target.files ?? []))}
        />
        <span>Selecionar arquivos</span>
        <small>Os arquivos são lidos somente pelo navegador.</small>
      </label>
      {files.length > 0 && (
        <ul className="file-list">
          {files.map((file) => (
            <li key={`${file.name}-${file.size}-${file.lastModified}`}>
              <span>{file.name}</span>
              <small>{(file.size / 1024).toFixed(1)} KB</small>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
